// テキストメッセージ
export interface TextMessage {
  type: "text";
  body: string;
  dateCreated: number;
}

// 添付ファイルメッセージ
export interface MediaMessage {
  type: "media";
  attacheMedia: BroadcastMedia;
  dateCreated: number;
}

export type BroadcastMessage = TextMessage | MediaMessage;

// 添付ファイル詳細
export interface BroadcastMedia {
  fileName: string;
  fileSize: number;
  mediaUrl: string;
  contentType: string;
}

/**
 * 一斉送信メッセージを取得する。
 *
 * 同意チェックは JSON / XHR に本文が空の 403 を返すため、
 * 403 は JSON として解析せず null を返して呼び出し側に案内を表示させる。
 *
 * @param endpoint トークルームのエンドポイント
 * @param page 取得するページ番号
 * @returns メッセージの配列。取得を拒否された場合は null
 * @throws 403 以外の失敗
 */
export const fetchBroadcastMessages = async (
  endpoint: string,
  page: number,
): Promise<BroadcastMessage[] | null> => {
  // JSON を受け取るので、同意チェック等でフルページの HTML を返されないようにする
  const res = await fetch(`/mypage/talkrooms/${endpoint}?page=${page}`, {
    headers: {
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
  });

  if (res.status === 403) return null;

  if (!res.ok) {
    throw new Error(`Failed to fetch broadcast messages: ${res.status}`);
  }

  return res.json();
};
